export default __webpack_public_path__ + "static/media/480_dummy2016-yoga01-de.fb4855b9.png";